import React from 'react';

export interface ProgressBarProps {
  currentStep: number;
  totalSteps?: number;
}

const ProgressBar = ({ currentStep, totalSteps = 3 }: ProgressBarProps): JSX.Element => {
  const percent = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

  return (
    <div className="form-step-progress">
      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={currentStep}
          aria-valuemin={1}
          aria-valuemax={totalSteps}
        />
      </div>
      <div className="progress-step-label">
        {currentStep}/{totalSteps}
      </div>
    </div>
  );
};

export default ProgressBar;
